<template>
  <div>
    <navbar/>
    <router-view class="mt-5 py-3"/>
    <Appfooter/>
  </div>
</template>

<script>
import navbar from '@/components/common/navbar'
import Appfooter from '@/components/common/AppFooter'
export default {
  name : "app",
  components : {
    navbar,
    Appfooter
  },
  data : () =>({

  }),
  methods : {

  }
}
</script>